import { render } from "./tplMembers.vue?vue&type=template&id=7044bccc"
import script from "./tplMembers.vue?vue&type=script&lang=js"
export * from "./tplMembers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__